// const onFacetClick = (event, facet) => {
// 	facet.parentNode.classList.toggle('advanced-query__facet--opened');
// }

// const initFacetMenus = () =>{
//     const facets = document.querySelectorAll('.advanced-query__facet-toggle');

// 	[...facets].map((facet) => {
// 		facet.addEventListener('click', (event) => onFacetClick(event, facet));
// 	});

// }

// export default initFacetMenus();

function copyNode( from, to ) {
	to.innerHTML = from.innerHTML;

	for ( let attribute of from.attributes ) {
		to.setAttribute( attribute.name, attribute.value );
	}
}

export class AdvancedQuery {
	constructor( node, opts = {} ) {
		this.node = node;
		this.opts = {
			ajax: true,
			queryId: null,
			postTemplate: '.advanced-query__grid',
			pagination: '.advanced-query__pagination',
			openedClass: 'facets--opened',
			opener: '.facets__heading--mobile',
			heading: '.advanced-query__heading',
			paginationLink: '.advanced-query__pagination a',
			form: '.advanced-query__form',
			facets: '.advanced-query__facet',
			facetsOpened: 'advanced-query__facet--opened',
			facetsToggle: '.advanced-query__facet-toggle',
			...opts
		}

		this.postTemplate = this.node.querySelector( this.opts.postTemplate );
		this.pagination   = this.node.querySelector( this.opts.pagination );
		this.form         = this.node.querySelector( this.opts.form );
		this.heading      = this.node.querySelector( this.opts.heading );

		this.opener     = typeof this.opts.opener === 'string' ? document.querySelector( this.opts.opener ) : this.opts.opener;
		this.opened     = this.node.classList.contains( this.opts.openedClass );
		this.wasFocused = null;

		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
			this.fetch( this.url() );
		});

		this.node.addEventListener('change', ( { target } ) => {
			if ( [ 'checkbox', 'radio' ].includes( target.type ) ) {
				this.wasFocused = `[name="${target.name}"][value="${target.value}"]`;
				this.fetch( this.url() );
			}
		});

		this.node.addEventListener('click', (e) => {
			if ( e.target.matches( this.opts.facetsToggle ) ) {
				const facet = e.target.closest( this.opts.facets );

				if ( facet ) {
					facet.classList.toggle( this.opts.facetsOpened );
				}
			}
		});

		this.node.addEventListener( 'input', (e) => {
			if ( ! e.target.matches('.advanced-query__facet-search input[type="text"]') ) {
				return;
			}

			const search = e.target.value.toLowerCase().replace( /\s/g, '' );
			const list   = e.target.closest( 'ul' );

			if ( ! list ) {
				return;
			}

			const items = Array.from( list.children ).filter( n => ! n.classList.contains( 'advanced-query__facet-search' ) );

			items.forEach( item => {
				if ( ! search ) {
					return item.style.display = '';
				}

				if ( ! item.textContent.replace( /\s/g, '' ).toLowerCase().includes( search ) ) {
					return item.style.display = 'none';
				}

				return item.style.display = '';
			} );
		});

		this.node.addEventListener('reset', (e) => {
			for ( let elem of this.node.elements ) {
				if ( elem.type ) {
					switch ( elem.type ) {
						case 'radio':
						case 'checkbox':
							elem.removeAttribute('checked');
						break;
						case 'hidden':
							// no-op
						break;
						default:
							elem.value = '';
						break;
					}
				}
			}

			this.fetch( this.url() );
		});

		if ( this.node ) {
			this.node.addEventListener( 'click', ( e ) => {
				if ( e.target.matches( this.opts.paginationLink ) ) {
					e.preventDefault();
					this.fetch( e.target.href );
				}
			});
		}

		if ( this.opts.ajax ) {
			window.addEventListener( 'popstate', (e) => this.fetch( location.href, false ) );
		}

		if ( this.opener ) {
			this.opener.addEventListener( 'click', this.toggle.bind(this) );
		}
	}

	url() {
		let { origin, pathname } = location;

		const formData         = new FormData( this.form );
		const formSearchParams = new URLSearchParams( formData );
		const urlSearchParams  = new URLSearchParams( location.search );

		// remove any fields from the url params that overlap with fields on the form
		Array.from( this.form.elements ).map( el => el.name ).filter( v => v ).forEach( ( name ) => {
			urlSearchParams.delete( name );
		} );

		// add form params to the url params
		for ( let param of formSearchParams.keys() ) {
			const values = formSearchParams.getAll( param );

			for ( let value of values ) {
				if ( ! urlSearchParams.has( param, value ) ) {
					urlSearchParams.append( param, value );
				}
			}
		}

		pathname = pathname.replace( /\/page\/[\d]+(\/)?$/, '$1' );
		urlSearchParams.delete( 'page' );

		if ( urlSearchParams.has( 'filter[paged]' ) ) {
			urlSearchParams.delete( 'filter[paged]' );
		}

		// remove empty values
		for ( let param of Array.from( urlSearchParams.keys() ) ) {
			if ( ! urlSearchParams.get( param ) ) {
				urlSearchParams.delete( param );
			}
		}

		const hasQueryString = Array.from( urlSearchParams.keys() ).length > 0;

		return `${ origin }${ pathname }${ hasQueryString ? '?' : '' }${ urlSearchParams }`;
	}

	async fetch( url, history = true ) {
		if ( ! this.opts.ajax ) {
			window.location.href = url;
			return;
		}

		this.node.classList.add('is-loading');
		this.node.querySelectorAll('fieldset').forEach( facet => facet.disabled = true );

		return fetch( url ).then( ( response ) => {
			return response.text();
		} ).then( html => {
			// @see - https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
			const parser       = new DOMParser();
			const doc          = parser.parseFromString( html, 'text/html' );
			const form         = doc.querySelector( this.opts.form );
			const postTemplate = doc.querySelector( this.opts.postTemplate );
			const pagination   = doc.querySelector( this.opts.pagination );
			const heading      = doc.querySelector( this.opts.heading );

			if ( form ) {
				copyNode( form, this.form );
			} else {
				this.form.innerHTML = '';
			}

			if ( pagination ) {
				copyNode( pagination, this.pagination );
			} else {
				this.pagination.innerHTML = '';
			}

			if ( postTemplate ) {
				copyNode( postTemplate, this.postTemplate );
			} else {
				this.postTemplate.innerHTML = '';
			}

			if ( heading ) {
				copyNode( heading, this.heading );
			} else {
				this.postTemplate.innerHTML = '';
			}

			// re-initialize panels
			this.node.querySelectorAll('.panels__panel').forEach( p => new Panel( p ) );

			this.node.dispatchEvent( new CustomEvent( 'facet:reload', { bubbles: true, cancelable: false } ) )

			if ( history ) {
				window.history.pushState( {}, '', url );
			}
		} ).catch( ( error ) => {
			console.error( error );
			window.location.href = url;
		} ).finally( () => {
			this.node.classList.remove('is-loading');
			this.node.querySelectorAll('fieldset').forEach( facet => facet.removeAttribute('disabled') );

			if ( this.node.getBoundingClientRect().top < 0 ) {
				this.node.scrollIntoView( { behavior: 'smooth' } );
			}
		} );
	}

	toggle() {
		return this.node.classList.contains( this.opts.openedClass ) ? this.close() : this.open();
	}

	open() {
		this.node.classList.add( this.opts.openedClass );
	}

	close() {
		this.node.classList.remove( this.opts.openedClass );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	Array.from( document.querySelectorAll('.advanced-query') ).map( node => new AdvancedQuery( node ) );
} );
